// src/modules/config/components/DiscountModal.tsx - ИСПРАВЛЕННЫЕ ИМПОРТЫ
import React from 'react';
import {
  Modal,
  Form,
  InputNumber,
  Button,
  Space
} from 'antd';
import { MenuItem } from '@/types'; // ИСПРАВЛЕНО: Импорт из @/types

interface DiscountModalProps {
  visible: boolean;
  menuItem: MenuItem | null;
  loading: boolean;
  onCancel: () => void;
  onSubmit: (discountPercent: number) => void;
}

export const DiscountModal: React.FC<DiscountModalProps> = ({
  visible,
  menuItem,
  loading,
  onCancel,
  onSubmit
}) => {
  const [form] = Form.useForm();

  const handleSubmit = async (values: any) => {
    await onSubmit(values.discount_percent);
    form.resetFields();
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title={`Создать скидку для: ${menuItem?.name || ''}`}
      open={visible}
      onCancel={handleCancel}
      footer={null}
      width={400}
      destroyOnHidden
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
      >
        <Form.Item
          name="discount_percent"
          label="Процент скидки"
          rules={[
            { required: true, message: 'Введите процент скидки' },
            { type: 'number', min: 1, max: 90, message: 'Скидка должна быть от 1% до 90%' }
          ]}
        >
          <InputNumber
            min={1}
            max={90}
            style={{ width: '100%' }}
            placeholder="Введите процент"
            addonAfter="%"
          />
        </Form.Item>
        
        <Form.Item>
          <Space>
            <Button type="primary" htmlType="submit" loading={loading}>
              Создать скидку
            </Button>
            <Button onClick={handleCancel}>
              Отмена
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};